import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import UpdateReceiptForm from 'components/features/update-receipt-form';

function UpdateReceipt() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('cashReceipts.updateReceipt')}>
      <UpdateReceiptForm />
    </HomeLayout>
  );
}

export default UpdateReceipt;
